module.exports = __webpack_public_path__ + "static/media/banesco-plus.59d0555a.svg";